import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { KeyRound, CheckCircle2 } from "lucide-react";
import { api, errorText, PASSWORD_HINT } from "@/lib/api";
import { TopBar } from "@/components/TopBar";
import { Footer } from "@/components/Footer";
import { TextField } from "@/components/tools/fields";
import { ErrorText } from "@/components/rc/shared";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("The two passwords don't match.");
    try {
      await api.post("/rc/password/reset", { token, password: pw });
      setDone(true);
    } catch (err) {
      setError(errorText(err));
    }
    return undefined;
  };
  return (
    <>
      <TopBar minimal />
      <main id="main" tabIndex={-1} className="outline-none">
        <section className="mx-auto max-w-lg px-5 pb-20 pt-[150px] lg:pt-[178px]" aria-labelledby="reset-title">
          <div className="rounded-[2rem] border-2 border-line bg-surface p-6 sm:p-8">
            <h1 id="reset-title" className="font-display text-4xl font-medium">Set a new password</h1>
            {done ? (
              <div role="status" className="mt-5 space-y-4" data-testid="reset-success">
                <p className="flex items-center gap-2 font-bold"><CheckCircle2 className="text-brand" aria-hidden /> Your password has been changed. You've been signed out on every device.</p>
                <Link to="/workspace?mode=signin" className="btn btn-brand" data-testid="reset-signin">Sign in</Link>
              </div>
            ) : !token ? (
              <p className="mt-4 text-ink-soft" data-testid="reset-missing">This link is incomplete. Please ask your SENDCO or Headteacher for a new reset link.</p>
            ) : (
              <form onSubmit={submit} noValidate className="mt-5 space-y-4" data-testid="reset-form">
                <TextField id="rp-1" label="New password" type="password" autoComplete="new-password" value={pw} onChange={setPw} testid="reset-password" />
                <p className="-mt-2 text-sm text-ink-soft">{PASSWORD_HINT}</p>
                <TextField id="rp-2" label="Type it again" type="password" autoComplete="new-password" value={pw2} onChange={setPw2} testid="reset-password-confirm" />
                <ErrorText error={error} testid="reset-error" />
                <button type="submit" className="btn btn-brand w-full" data-testid="reset-submit"><KeyRound size={16} aria-hidden /> Save new password</button>
              </form>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
